import { createAction } from 'redux-actions'
import {
  ADD_GL_CODE,
  ADD_GL_CODE_FAILED,
  ADD_GL_CODE_SUCCEEDED,
  DELETE_GL_CODE,
  DELETE_GL_CODE_FAILED,
  DELETE_GL_CODE_SUCCEEDED,
  GET_GL_CODES,
  GET_GL_CODES_FAILED,
  GET_GL_CODES_SUCCEEDED,
  UPDATE_GL_CODE,
  UPDATE_GL_CODE_FAILED,
  UPDATE_GL_CODE_SUCCEEDED,
  FETCH_EXPENSE_GLCODE_TAGS,
  FETCH_EXPENSE_GLCODE_TAGS_FAILED,
  FETCH_EXPENSE_GLCODE_TAGS_SUCCEEDED,
} from 'Redux/Types/GLCodeTypes'

export const addGLCode = createAction(ADD_GL_CODE)
export const addGLCodeFailed = createAction(ADD_GL_CODE_FAILED)
export const addGLCodeSucceeded = createAction(ADD_GL_CODE_SUCCEEDED)

export const deleteGLCode = createAction(DELETE_GL_CODE)
export const deleteGLCodeFailed = createAction(DELETE_GL_CODE_FAILED)
export const deleteGLCodeSucceeded = createAction(DELETE_GL_CODE_SUCCEEDED)

export const getGLCodes = createAction(GET_GL_CODES)
export const getGLCodesFailed = createAction(GET_GL_CODES_FAILED)
export const getGLCodesSucceeded = createAction(GET_GL_CODES_SUCCEEDED)

export const updateGLCode = createAction(UPDATE_GL_CODE)
export const updateGLCodeFailed = createAction(UPDATE_GL_CODE_FAILED)
export const updateGLCodeSucceeded = createAction(UPDATE_GL_CODE_SUCCEEDED)

export const fetchExpenseGlCodeTags = createAction(FETCH_EXPENSE_GLCODE_TAGS)
export const fetchExpenseGlCodeTagsFailed = createAction(FETCH_EXPENSE_GLCODE_TAGS_FAILED)
export const fetchExpenseGlCodeTagsSucceeded = createAction(FETCH_EXPENSE_GLCODE_TAGS_SUCCEEDED)
